export const defaultCriteriaFilter = {
    filterForms: [],
    searchForms: [],
    filters: [],
    dateFilter: undefined
};
